import {WithChildren} from "../../types/WithChildren";
import {ListItem, useMediaQuery} from "@mui/material";

export default function DynamicListItem({children}: WithChildren) {
  // @ts-ignore
  const align = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <ListItem alignItems={align ? "flex-start" : "center"}>
      {children}
    </ListItem>
  )
}